import { getFileTypeNameFromType } from '@office-start/file-utility';
import { getAppSecurityLevel, logImpressionEvent, } from '@office-start/instrumentation-service';
import { DataSecurityLevel, KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logFeature, logImpression } from '@office-start/telemetry-service';
export function logEdgeworthImpression(_a) {
    var _b, _c;
    var documents = _a.documents, logDistribution = _a.logDistribution, instrumentationArea = _a.instrumentationArea;
    var params = {};
    var loggableDisplayItems = getAppSecurityLevel() >= DataSecurityLevel.Enhanced
        ? documents
        : documents.filter(function (doc) { return !doc.isLocalFile; });
    var distribution = '';
    if (logDistribution && loggableDisplayItems.length) {
        var counter_1 = {};
        loggableDisplayItems.forEach(function (item) {
            var _a, _b;
            var contentType = item.substrateInfo
                ? ((_a = item.substrateInfo) === null || _a === void 0 ? void 0 : _a.contentDomain) ||
                    ((_b = item.substrateInfo) === null || _b === void 0 ? void 0 : _b.contentDomainInstanceId) ||
                    'SCD: unknown'
                : getFileTypeNameFromType(item.fileType);
            if (!counter_1[contentType]) {
                counter_1[contentType] = 1;
            }
            else {
                counter_1[contentType]++;
            }
        });
        distribution = Object.keys(counter_1).reduce(function (combined, current, index) {
            return combined +
                (index === 0 ? '' : ';') +
                "".concat(current, ":").concat(counter_1[current]);
        }, '');
        params['Distribution'] = distribution;
    }
    params['ElementId'] = 'edgeworth-list';
    if (instrumentationArea) {
        params['Area'] = instrumentationArea;
    }
    params['RenderSize'] = ((loggableDisplayItems === null || loggableDisplayItems === void 0 ? void 0 : loggableDisplayItems.length) || 0).toString();
    logImpressionEvent(KnownInstrumentationEvents.EdgeworthImpression, params);
    // TODO: Remove above Aria logging after fully migrating to OTEL
    logImpression({
        eventName: "Edgeworth" /* KnownImpressionInstrumentationEvents.EdgeworthImpression */,
        area: (_b = instrumentationArea) !== null && _b !== void 0 ? _b : 'Other',
        distribution: distribution,
        renderSize: (loggableDisplayItems === null || loggableDisplayItems === void 0 ? void 0 : loggableDisplayItems.length) || 0,
    });
    logFeature({
        featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
        eventName: "Edgeworth" /* KnownImpressionInstrumentationEvents.EdgeworthImpression */,
        params: params,
        area: (_c = instrumentationArea) !== null && _c !== void 0 ? _c : 'Other',
    });
}
//# sourceMappingURL=logEdgeworthImpression.js.map